import { playerTypes } from "../playerTypes";

import { Player } from "../../interfaces/player/player.interface";


export const defaultPlayer: Player = playerTypes.filter(p => p.type.mode === 'player' && p.type.design === 'compact')[0]